import { useState } from 'react';
import { Loading } from '../../../../components/Loading';

export const CancelModal = ({ onConfirm, onCancel }: { onConfirm: () => void; onCancel: () => void }) => {
    const [loading, setLoading] = useState(false);

    const onClickConfirm = async () => {
        try {
            setLoading(true);
            await onConfirm();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // Acao destrutiva primeiro e com rotulo explicito; "Manter" evita o ambiguo "Cancelar".
    return (
        <div className="flex flex-col gap-2 sm:flex-row-reverse sm:justify-start">
            <button className="btn btn-error w-full sm:w-auto" onClick={onClickConfirm} disabled={loading}>
                {loading ? <Loading /> : 'Cancelar agendamento'}
            </button>
            <button className="btn btn-ghost w-full sm:w-auto" onClick={onCancel} disabled={loading}>
                Manter agendamento
            </button>
        </div>
    );
};
